// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'or',
  return: {
    text: 'Return to homepage',
    title: 'click here to cancel and return to home page',
  },
  create: {
    text: 'Create an account',
    title: 'click here to cancel and create new credentials',
  },
} as ILanguage;
